import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function (state) {
    return new Vuex.Store({
        state: {
            audioPlaying: false,
            ...state
        },
        mutations: {
            //
        },
        actions: {
            //
        },
    })
}
